export interface SolicitacaoEnterpriseResponse {
    id: number;
    imobiliariaId: number;
    imobiliariaNome: string;
    imobiliariaCnpj: string;
    imobiliariaEmail: string;
    imobiliariaTelefone: string;
    usuarioSolicitanteId: number;
    usuarioSolicitanteNome: string;
    usuarioSolicitanteEmail: string;
    planoAtualId: number;
    planoAtualNome: string;
    quantidadeUsuariosAtivos: number;
    mensagem: string | null;
    dataSolicitacao: Date;
    dataAtendimento: Date | null;
    atendidoPorId: number | null;
    atendidoPorNome: string | null;
    status: StatusSolicitacaoEnterprise;
    statusDescricao: string;
    observacoes: string | null;
}

export enum StatusSolicitacaoEnterprise {
    Pendente = 0,
    EmAtendimento = 1,
    Concluido = 2,
    Cancelado = 3
}

export interface AtualizarStatusEnterpriseRequest {
    status: StatusSolicitacaoEnterprise;
    observacoes?: string;
}

export interface AprovarEnterpriseRequest {
    valorMensal: number;
    observacoes?: string;
}

export interface AprovarEnterpriseResponse {
    sucesso: boolean;
    message: string;
    novaAssinaturaId?: number;
}
